<template>
  <div class="flex items-center text-sm">
    <button
      @click="goToPage(1)"
      :disabled="currentPage === 1"
      class="flex justify-center items-center bg-white h-10 w-10 border text-coal hover:enabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    >
      <font-awesome-icon icon="fa-solid fa-angle-double-left" />
    </button>
    <button
      @click="prevPage"
      :disabled="currentPage === 1"
      class="flex justify-center items-center bg-white h-10 w-10 border text-coal hover:enabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    >
      <font-awesome-icon icon="fa-solid fa-angle-left" />
    </button>

    <button
      v-for="page in displayedPages"
      :key="page"
      @click="goToPage(page)"
      class="h-10 w-10 border text-coal"
      :class="
        currentPage === page
          ? `bg-gold font-bold`
          : `bg-white hover:bg-gray-200`
      "
    >
      {{ page }}
    </button>

    <button
      @click="nextPage"
      :disabled="currentPage === totalPages"
      class="flex justify-center items-center bg-white h-10 w-10 border text-coal hover:enabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    >
      <font-awesome-icon icon="fa-solid fa-angle-right" />
    </button>
    <button
      @click="goToPage(totalPages)"
      :disabled="currentPage === totalPages"
      class="flex justify-center items-center bg-white h-10 w-10 border text-coal hover:enabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    >
      <font-awesome-icon icon="fa-solid fa-angle-double-right" />
    </button>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";

export default {
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentPage = ref(props.modelValue);

    watch(
      () => props.modelValue,
      (newVal) => {
        currentPage.value = newVal;
      }
    );

    const displayedPages = computed(() => {
      const pages = [];

      const start = Math.max(1, currentPage.value - 2);
      const end = Math.min(props.totalPages, currentPage.value + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    });

    const goToPage = (page) => {
      currentPage.value = page;
      emit("page-changed", page);
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        goToPage(currentPage.value - 1);
      }
    };

    const nextPage = () => {
      if (currentPage.value < props.totalPages) {
        goToPage(currentPage.value + 1);
      }
    };

    return {
      currentPage,
      displayedPages,
      goToPage,
      prevPage,
      nextPage,
    };
  },
};
</script>
